import { StubModule } from "../../../shared/components/StubModule";
import { useConnectAction } from "../../../services/auth/useConnectAction";

interface TranscribeModuleProps {
  readonly onBack?: () => void;
  readonly onOpenSettings?: () => void;
}

export function TranscribeModule({
  onBack,
  onOpenSettings,
}: Readonly<TranscribeModuleProps> = {}) {
  const connectAction = useConnectAction("transcribe", "Connect Transcribe");
  return (
    <StubModule
      title="Transcribe QC"
      subtitle="Audio transcription review and editing"
      noticeTitle="Connect Transcribe to continue"
      noticeMessage="Transcribe uses AWS Cognito (us-east-1) authentication."
      features={[
        "Pack management with search, status filter, pagination",
        "Audio upload with file validation + S3 presigned URLs",
        "Dash.js audio player (play/pause/seek/volume)",
        "Block editing: speaker assignment, auto-save, find & highlight",
        "Block merging and dictation mode",
        "Export with template selection and download",
      ]}
      onBack={onBack}
      connectAction={connectAction}
      onOpenSettings={onOpenSettings}
    />
  );
}
